import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { StickyCheckoutBar } from "../components/StickyCheckoutBar";
import usePageMeta from "../hooks/usePageMeta";
import { Link } from "react-router-dom";

export default function Shop() {
  const [products, setProducts] = useState(null);
  usePageMeta("Shop Cold-Pressed Juice Singles & Packs | Tiff Wellness Co.", "Compare all six juices — functional blends with clear protein, BCAAs or creatine from $12, traditional Renew+ from $10 — and build your Dallas pickup order.", {
    schemaType: "CollectionPage",
    jsonLd: products?.length ? { "@context": "https://schema.org", "@type": "ItemList",
      itemListElement: products.map((p, i) => ({ "@type": "ListItem", position: i + 1, name: p.name, url: `${window.location.origin}/products/${p.slug}` })) } : null,
  });
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);
  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <p className="eyebrow mb-2">Shop</p>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl mb-3">Shop Cold-Pressed Juices in Dallas</h1>
      <p className="text-sm text-[#171715]/70 max-w-2xl mb-10">Six 12 fl oz juices, made fresh in small batches. Functional juices (with clear protein, BCAAs or creatine): $12 single · $28 per 3 · $54 per 6, mix &amp; match applied automatically. Renew+ (traditional, no added supplement): $10 single — traditional pack pricing pending confirmation. Test reference prices.</p>
      <h2 className="text-lg font-medium mb-5">Explore All Six Juices</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="shop-product-grid">
        {products === null
          ? [...Array(6)].map((_, i) => <div key={i} className="card-paper h-64 animate-pulse" aria-hidden="true" />)
          : products.map((p) => <ProductCard key={p.slug} p={p} />)}
      </div>
      <section className="mt-16">
        <h2 className="text-lg font-medium mb-4">Compare Ingredients and Add-ins</h2>
        <div className="overflow-x-auto card-paper">
          <table className="w-full text-sm min-w-[560px]" data-testid="shop-compare-table">
            <thead><tr className="border-b border-[#EBD9D0] text-left">
              <th className="p-3 font-medium">Juice</th><th className="p-3 font-medium">Ingredients (as listed)</th><th className="p-3 font-medium">Functional add-in</th><th className="p-3 font-medium">Price</th>
            </tr></thead>
            <tbody>
              {(products || []).map((p) => (
                <tr key={p.slug} className="border-b border-[#EBD9D0]/60 last:border-0">
                  <td className="p-3"><Link className="underline" to={`/products/${p.slug}`}>{p.name}</Link></td>
                  <td className="p-3 capitalize text-[#171715]/80">{p.ingredients.join(", ")}</td>
                  <td className="p-3">{p.functional_addition || "—"}</td>
                  <td className="p-3 font-mono">${(p.price_cents / 100).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-[#171715]/55 mt-2">Add-in amounts, nutrition and allergens are pending owner confirmation and are not shown until approved.</p>
      </section>
      <StickyCheckoutBar />
    </div>
  );
}
